module.exports = __webpack_public_path__ + "static/ishi-image-46f20ce502e04265ba2f2d406c222446.png";